export default "__VITE_ASSET__CjQPVreg__"